import { range } from 'lodash';
import { SPACE_LINE_BREAKPOINT, RESOURCE_WIDTH } from '../constants';
import { getResourceLegendWidth } from '../utils/drawUtils';
import { round } from '../utils/mathUtils';
import { TimelineState } from '../types';
import ResourceUsePlaceholder from './renderer/resourceUsePlaceholder';
import ConfirmedResourceUsePlaceholder from './renderer/confirmedResourceUsePlaceholder';

export default function Animator(
    state: TimelineState,
    model: $TSFixMe,
    spaceLegend: $TSFixMe,
    dateLegend: $TSFixMe,
    resourceUseCanvas: $TSFixMe,
    resourceUsePlaceholder: ReturnType<typeof ResourceUsePlaceholder> | undefined,
    confirmedResourceUsePlaceholder: ReturnType<typeof ConfirmedResourceUsePlaceholder> | undefined,
    quickScroll: $TSFixMe
) {
    let animationRequest: $TSFixMe = null;

    return {
        requestDraw() {
            if (!animationRequest) {
                animationRequest = window.requestAnimationFrame(() => {
                    animationRequest = null;

                    draw(state);
                });
            }
        },
    };

    function draw(timelineState: TimelineState) {
        const {
            ctx,
            xAxis,
            yAxis,
            selectedResourceUse,
            canvasWidth,
            canvasHeight,
            scale,
            highlightedSpaces,
            viewport,
            withResourceLegend,
            serviceId,
            timeUnit,
            searchedSpace,
        } = timelineState;
        const days = range(round(xAxis.invert(0)), round(xAxis.invert(canvasWidth)) + 1);
        const withLines = scale > SPACE_LINE_BREAKPOINT;
        const resourceWidth = round(RESOURCE_WIDTH * scale);
        const resourceLegendWidth = getResourceLegendWidth(model, scale, withResourceLegend);

        resourceUseCanvas.render({
            ctx,
            xAxis,
            yAxis,
            canvasWidth,
            canvasHeight,
            scale,
            days,
            resources: model.getVisibleResources(),
            resourceCategoryTypes: model.getVisibleRootResourceCategoryTypes(),
            resourceUses: model.getVisibleResourceUses(),
            selectedResourceUse,
            highlightedSpaces,
            withLines,
            viewport,
            resourceLegendWidth,
            timelineServiceId: serviceId,
            timeUnit,
        });

        // placeholders are undefined when user has no privilege to manage reservations
        resourceUsePlaceholder?.render(timelineState, model);
        confirmedResourceUsePlaceholder?.render(timelineState, model);

        dateLegend.render({
            ctx,
            xAxis,
            canvasWidth,
            canvasHeight,
            days,
            events: model.getVisibleEventsByDayIndex(),
            timeUnit,
            resourceLegendWidth,
        });
        spaceLegend.render({
            ctx,
            yAxis,
            canvasHeight,
            scale,
            highlightedSpaces,
            resources: model.getVisibleResources(),
            resourceCategoryTypes: model.getVisibleRootResourceCategoryTypes(),
            withLines,
            resourceLegendWidth,
            spaceWidth: resourceWidth,
            searchedSpace,
        });
        quickScroll.render({ ctx, canvasWidth });
    }
}
